
export default {
  allReports: [],
  // firstTimeLoad: false,
  // mainListQuickFilters: [],
  // quickFiltersDatesFrom: [],
  // quickFiltersDatesTo: [],
  // quickFiltersGroups: [],
  // sortField: '',
  // sortFieldId: 0,
  // sortOrder: 0,
  // page: 1,
  // rows: 25,
  // hardLoad: 0,
  // softReload: 0,
  // columns: []
  firstTimeLoad: [],
  mainListQuickFilters: [],
  quickFiltersDatesFrom: [],
  quickFiltersDatesTo: [],
  quickFiltersGroups: [],
  sortField: [],
  sortFieldId: [],
  sortOrder: [],
  page: [],
  rows: [],
  hardLoad: [],
  softReload: [],
  columns: []
}